import Helmet from 'react-helmet'
import Lato from 'typeface-lato' // eslint-disable-line no-unused-vars
import React from 'react'
import { BrowserRouter as Router } from 'react-router-dom'

import Image from 'components/Image'
import Link from 'components/Link'
import Nav from 'components/Nav'
import meta from 'constants/meta'
import paths from 'constants/paths'

import Routes from './Routes'
import logo from './images/logo.svg'
import logoInverted from './images/logo---inverted.svg'

import styles from './App.module.scss'

export default function App() {
  return (
    <Router>
      <div className={styles.this}>
        <Helmet>
          <title>
            {meta.TITLE}
          </title>
          <link rel="preconnect" href="https://maps.googleapis.com" crossOrigin />
        </Helmet>
        <div className="uk-navbar-container uk-navbar-transparent uk-dark">
          <div className="uk-container uk-container-expand">
            <div className="uk-navbar">
              <div className="uk-navbar-left">
                <Link to={paths.REPORTS} className="uk-navbar-item uk-logo">
                  <Image src={logo} alt={meta.TITLE} className="uk-responsive-height" />
                  <Image src={logoInverted} className="uk-logo-inverse uk-responsive-height" />
                </Link>
              </div>
              <div className="uk-navbar-right">
                <Nav />
              </div>
            </div>
          </div>
        </div>

        <Routes />
      </div>
    </Router>
  )
}



// WEBPACK FOOTER //
// ./src/components/App/App.js